import React, { createContext } from 'react';

const EncryptContext = createContext({});

export default EncryptContext;